import { DiffEditor, DiffEditorProps, loader } from "@monaco-editor/react";
import { CODE_EDITOR_DEFAULT_OPTIONS } from "./CodeEditor";
import styles from "./CodeEditor.module.css";
import { beforeMount } from "./beforeMount";

loader.config({ paths: { vs: "/vs" } });

type Props = Omit<DiffEditorProps, "className" | "options">; // Omitting these for convenience. They can likely be supported and manually merged below if needed.

export const DiffViewer = (props: Props) => {
  return (
    <DiffEditor
      className={styles.editor}
      theme="llama"
      beforeMount={beforeMount}
      options={{
        ...CODE_EDITOR_DEFAULT_OPTIONS,
        // Can't get left side to wrap.
        // See: https://github.com/microsoft/monaco-editor/discussions/4454
        // And: https://github.com/microsoft/monaco-editor/issues/4701
        diffWordWrap: "on",
        useInlineViewWhenSpaceIsLimited: false, // Does not play well with diffWordWrap - causes left panel to not wrap.
        readOnly: true,
        renderOverviewRuler: false,
      }}
      {...props}
    />
  );
};
